import value from "./repositories.json";
const StoredRepositories = value;
export default StoredRepositories;